// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"8233ebd9","287":"134d3019","356":"ed50a3ef","510":"628eab60","700":"33fe93b6"}[chunkId] + ".chunk.css";
};